import api from './api'
import axios from 'axios'
import { authService } from './authService'
import { normalizeOssUrlForPresign } from '@/utils/ossUrl'

// 创建用于文件上传的axios实例
const uploadApi = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/api',
  timeout: 600000,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

// 文件上传请求拦截器
uploadApi.interceptors.request.use((config) => {
  if (authService.isTokenExpired()) {
    localStorage.removeItem('user')
    window.location.href = '/'
    return Promise.reject(new Error('Token已过期'))
  }
  
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  if (user.token) {
    config.headers.Authorization = `Bearer ${user.token}`
  }
  return config
}, error => Promise.reject(error))

// 文件上传响应拦截器
uploadApi.interceptors.response.use(
  (response) => {
    if (response.data && response.data.success !== undefined) {
      return response.data
    }
    return response
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response
      if (status === 401) {
        localStorage.removeItem('user')
        window.location.href = '/'
      }
      console.error('上传失败:', data?.message || error.message)
    }
    return Promise.reject(error)
  }
)

export const therapyActivityService = {
  fetchList(params = {}) {
    const query = new URLSearchParams()
    if (params.status) query.append('status', params.status)
    if (params.categoryId) query.append('categoryId', params.categoryId)
    query.append('page', params.page ?? 0)
    query.append('size', params.size ?? 10)
    return api.get(`/therapy/activities?${query.toString()}`)
  },
  create(payload) {
    return api.post('/therapy/activities', payload)
  },
  update(id, payload) {
    return api.put(`/therapy/activities/${id}`, payload)
  },
  updateStatus(id, status) {
    return api.patch(`/therapy/activities/${id}/status`, null, { params: { status } })
  },
  checkDeactivate(id) {
    return api.get(`/therapy/activities/${id}/deactivate-check`)
  },
  uploadImage(file) {
    const formData = new FormData()
    formData.append('file', file)
    return uploadApi.post('/therapy/activities/images/upload', formData)
  },
  getPresignedUrl(imageUrl) {
    const clean = normalizeOssUrlForPresign(imageUrl)
    return api.get(`/therapy/activities/images/presigned-url?url=${encodeURIComponent(clean)}`)
  }
}
